export const companiesEs = {
  companies: `Empresas`,
  add_company: `Agregar Empresa`,
  company_id: `ID de empresa`,
  company_id_2: `ID de empresa 2`,
  company_id_3: `ID de empresa 3`,
  registration_ID_is_required: `Se requiere el ID de registro`,
  company_name_is_required: `El nombre de la empresa es obligatorio`,
  organization_id: `ID de la organización`,
  company_name: `Nombre de la empresa`,
  update_company: `Actualizar empresa`,
  delete_company_title: `Eliminar empresa`,
  delete_company_warning: `¿Está seguro de que desea eliminar esta empresa?`,
  company_deleted_successfully: `Empresa eliminada correctamente`,
  company_not_found: `Empresa no encontrada`,
  company_details: `Detalles de la empresa`,
  legal_representative: `Representante legal`,
  company_mail_inboxes: `Buzones de correo de la empresa`,
  create_mail_inbox: `Crear buzón de correo`,
  mail_inbox_created_successfully: `Buzón de correo creado correctamente`,
  mail_inbox_deleted_successfully: `Buzón de correo eliminado correctamente`,
  delete_mail_inbox_title: `Eliminar buzón de correo`,
  delete_mail_inbox_warning: `¿Está seguro de que desea eliminar este buzón de correo?`,
  mail_box_email: `Correo del buzón`,
  actions: `Acciones`,
  no_mail_inboxes_found: `No se encontraron buzones de correo`,
  filter_mail_inboxes: `Filtrar buzones de correo`,
  account_class: `Clase de cuenta`,
  account_receivable: `Cuentas por cobrar`,
  account_payable: `Cuentas por pagar`,
  document_type: `Tipo de documento`,
  invoice: `Factura`,
  purchase_order: `Orden de compra`,
  delivery_note: `Nota de entrega`,
  credit_note: `Nota de crédito`,
  debit_note: `Nota de débito`,
  user: `Usuario`,
  supplier: `Proveedor`,
  customer: `Cliente`,
  add_filter: `Agregar filtro`,
  customer_supplier_mutually_exclusive: `El cliente y el proveedor son mutuamente excluyentes`,
  supplier_not_allowed_with_account_receivable: `Proveedor no permitido con cuenta por cobrar`,
  mailbox_supplier_text: `Puedes especificar el proveedor que te enviará tus documentos por pagar`,
  mailbox_customer_text: `Puedes especificar el cliente que recibirá tus documentos por cobrar`,
  create_mail_inbox_address: `Crea un buzón personalizado y define su configuración de documentos, proveedores y clientes.`,
  manage_email_addresses_used_to_route_incoming_documents: `Gestiona las direcciones de correo electrónico utilizadas para recibir documentos entrantes`,
  mailbox_for_all_documents: `Para todos los documentos`,
  mailbox_for_only_scope: `Solo para {{accountClass}} • {{documentType}}`,
  all_accounts: `todas`,
  all_documents: `todos los documentos`,
  no_company_read_permission: `No tienes permiso para ver las empresas`,
};
